export const JPEG_QUALITY = '';
// ,{"jpeg":{"quality":70}}'